function stringComparatorAscending(a, b) {
  if (a < b) {
    return -1;
  } else if (a > b) {
    return 1;
  }
  return 0;
}

function stringComparatorDescending(a, b) {
  if (a > b) {
    return -1;
  } else if (a < b) {
    return 1;
  }
  return 0;
}

// eslint-disable-next-line import/prefer-default-export
export function createStringComparator(descending) {
  if (descending) {
    return stringComparatorDescending;
  }
  return stringComparatorAscending;
}
